export const CopyIcon2 = ({ color, size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "16"}
      height={size ?? "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11 5.5V4C11 3.17157 10.3284 2.5 9.5 2.5H4C3.17157 2.5 2.5 3.17157 2.5 4V9.5C2.5 10.3284 3.17157 11 4 11H5.5M11 5.5H12C12.8284 5.5 13.5 6.17157 13.5 7V12C13.5 12.8284 12.8284 13.5 12 13.5H7C6.17157 13.5 5.5 12.8284 5.5 12V11M11 5.5H7C6.17157 5.5 5.5 6.17157 5.5 7V11"
        stroke={color ?? "#656575"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

/**
 *
 * @param {Object} props
 * @param {string} [props.color]
 * @param {string} [props.size]
 * @returns
 */
const CopyIcon = ({ color, size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "20"}
      height={size ?? "20"}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9 2C7.89543 2 7 2.89543 7 4V12C7 13.1046 7.89543 14 9 14H15C16.1046 14 17 13.1046 17 12V6.41421C17 5.88378 16.7893 5.37507 16.4142 5L14 2.58579C13.6249 2.21071 13.1162 2 12.5858 2H9Z"
        fill={color ?? "#032250"}
      />
      <path
        d="M3 8C3 6.89543 3.89543 6 5 6V16H13C13 17.1046 12.1046 18 11 18H5C3.89543 18 3 17.1046 3 16V8Z"
        fill={color ?? "#032250"}
      />
    </svg>
  );
};

export default CopyIcon;
